import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import Snackbar from '../../Snackbar';
import IconPhone from '../../../icons/IconPhone';
import LoginTextField from '../../../fields/normal/LoginTextField';
import styles from './style';

const validate = values => {
  const errors = {};
  const requiredFields = ['email', 'password'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address';
  }
  return errors;
};

const renderTextField = ({
  label,
  labelTouched,
  labelUntouched,
  FormHelperText,
  input,
  meta: { touched, invalid, error, dirty, active },
  ...custom
}) => (
  <LoginTextField
    label={
      label || (labelTouched && dirty) || active || touched
        ? labelTouched
        : labelUntouched || 'generic label'
    }
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);

const LoginForm = props => {
  const {
    handleSubmit,
    handleForgotPw,
    pristine,
    reset,
    submitting,
    classes,
    invalid,
    isLoginLoading,
    submitFailed,
    error,
  } = props;

  const [loginSnackbarOpen, setLoginSnackbarOpen] = useState(false);

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.fieldContain}>
        <Field
          name="email"
          component={renderTextField}
          labelUntouched={
            <Typography variant="h6" className={classes.placeText}>
              enter email address
            </Typography>
          }
          labelTouched={
            <Typography variant="h6" className={classes.placeText}>
              email address
            </Typography>
          }
        />
      </div>
      <div className={classes.fieldContain}>
        <Field
          name="password"
          component={renderTextField}
          labelUntouched={
            <Typography variant="h6" className={classes.placeText}>
              enter password
            </Typography>
          }
          labelTouched={
            <Typography variant="h6" className={classes.placeText}>
              password
            </Typography>
          }
          type="password"
        />
        <Typography
          variant="body2"
          onClick={handleForgotPw}
          className={classes.forgotPwLinkContain}
        >
          Forgot your password?
        </Typography>
      </div>
      {submitFailed && error && (
        <div className={classes.submitFailedContain}>
          <Typography
            className={classes.submitFailed_message}
            onClick={() => reset('LoginForm')}
            variant="body2"
            color="error"
          >
            {error}
          </Typography>
          <Typography
            className={classes.submitFailed_link}
            onClick={() => reset('LoginForm')}
            variant="button"
          >
            Try again
          </Typography>
        </div>
      )}
      <div className={classes.buttonContain}>
        <Button
          className={classes.mainButton}
          // style={{ height: '61px' }}
          type="submit"
          disabled={pristine || submitting || invalid || isLoginLoading}
          variant="contained"
          color="primary"
          name="loginButton"
          fullWidth
        >
          Login
          {isLoginLoading && (
            <CircularProgress size={34} className={classes.buttonProgress} />
          )}
        </Button>
      </div>
      <Snackbar
        open={loginSnackbarOpen}
        onClose={() => setLoginSnackbarOpen(false)}
        message={
          <span>
            Please contact James Hardie at
            <span className={classes.number}> 13-11-03 </span>
            for assistance with your account.
          </span>
        }
        IconComponent={IconPhone}
      />
    </form>
  );
};

renderTextField.propTypes = {
  label: PropTypes.any,
  labelTouched: PropTypes.any,
  labelUntouched: PropTypes.any,
  FormHelperText: PropTypes.any,
  input: PropTypes.any,
  meta: {
    touched: PropTypes.any,
    invalid: PropTypes.any,
    error: PropTypes.any,
    dirty: PropTypes.any,
    active: PropTypes.any,
  },
};

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleForgotPw: PropTypes.func,
  pristine: PropTypes.any,
  reset: PropTypes.any,
  submitting: PropTypes.any,
  classes: PropTypes.object,
  invalid: PropTypes.any,
  isLoginLoading: PropTypes.bool,
  submitFailed: PropTypes.any,
  error: PropTypes.any,
};

export default withStyles(styles)(
  reduxForm({
    form: 'LoginForm', // a unique identifier for this form
    validate,
  })(LoginForm),
);
